import { render, staticRenderFns } from "./AggregateStock.vue?vue&type=template&id=532e3ef0&scoped=true&"
import script from "./AggregateStock.vue?vue&type=script&lang=ts&"
export * from "./AggregateStock.vue?vue&type=script&lang=ts&"
import style0 from "./AggregateStock.vue?vue&type=style&index=0&id=532e3ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532e3ef0",
  null
  
)

export default component.exports